import { getSocialIconUrl } from './socialIcons';

const getPadding = (content) => {
  const pt = content.paddingTop ?? content.padding ?? '16px';
  const pr = content.paddingRight ?? content.padding ?? '16px';
  const pb = content.paddingBottom ?? content.padding ?? '16px';
  const pl = content.paddingLeft ?? content.padding ?? '16px';
  return `${pt} ${pr} ${pb} ${pl}`;
};

export function isEmptyRichHtml(html) {
  if (!html) return true;
  const text = String(html)
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .trim();
  return text.length === 0;
}

export function compileBlocksToEmailHtml(blocks) {
  const contentHtml = blocks
    .map((block) => {
      const { type, content } = block;

      switch (type) {
        case 'HEADING':
        case 'TEXT':
        case 'QUOTE':
        case 'FOOTER': {
          const paddingStr = getPadding(content);
          const style =
            type === 'QUOTE'
              ? `background-color:${content.backgroundColor}; border-left:${content.borderLeft}; padding:${paddingStr};`
              : `padding:${paddingStr}; text-align:${content.align || 'left'};`;
          return `
          <tr>
            <td align="${content.align || 'left'}" style="${style}">
              ${content.html || ''}
            </td>
          </tr>
        `;
        }

        case 'LOGO':
        case 'IMAGE': {
          if (!content.url) return '';
          const imgAlign = content.align || 'center';
          const imgWidth = content.width || '100%';
          const imgPadding = getPadding(content);
          const borderRadius = content.borderRadius
            ? `border-radius: ${content.borderRadius};`
            : '';

          let imgTag = `<img src="${escapeHtml(content.url)}" alt="${escapeHtml(content.alt || '')}" width="${escapeHtml(imgWidth)}" style="display: block; max-width: 100%; height: auto; ${borderRadius}" />`;

          if (content.link) {
            imgTag = `<a href="${escapeHtml(content.link)}" target="_blank" style="text-decoration: none;">${imgTag}</a>`;
          }

          return `
          <tr>
            <td align="${imgAlign}" style="padding: ${imgPadding};">
              ${imgTag}
            </td>
          </tr>
        `;
        }

        case 'BUTTON': {
          const btnAlign = content.align || 'center';
          const btnBg = content.backgroundColor || '#22c55e';
          const btnColor = content.textColor || '#ffffff';
          const btnRadius = content.borderRadius || '8px';
          const btnPadding = getPadding(content);
          const fontSize = content.fontSize || '16px';
          const fontWeight = content.fontWeight || 'bold';

          return `
          <tr>
            <td align="${btnAlign}" style="padding: ${btnPadding};">
              <table border="0" cellspacing="0" cellpadding="0">
                <tr>
                  <td align="center" bgcolor="${btnBg}" style="border-radius: ${btnRadius};">
                    <a href="${escapeHtml(content.url || '#')}" target="_blank" style="font-size: ${fontSize}; font-family: Helvetica, Arial, sans-serif; color: ${btnColor}; font-weight: ${fontWeight}; text-decoration: none; padding: 12px 24px; border: 1px solid ${btnBg}; display: inline-block; border-radius: ${btnRadius};">
                      ${escapeHtml(content.text)}
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        `;
        }

        case 'SOCIAL': {
          const socAlign = content.align || 'center';
          const socPadding = getPadding(content);
          const iconSize = content.iconSize || '32px';
          const spacing = content.spacing || '16px';

          const socialLinksHtml = (content.networks || [])
            .map((net) => {
              const iconUrl = getSocialIconUrl(net.platform, net.iconUrl);
              return `
            <td style="padding: 0 ${parseInt(spacing) / 2}px;">
              <a href="${escapeHtml(net.url)}" target="_blank">
                <img src="${iconUrl}" alt="${net.platform}" width="${parseInt(iconSize)}" height="${parseInt(iconSize)}" style="display: block; border: 0;" />
              </a>
            </td>
          `;
            })
            .join('');

          return `
          <tr>
            <td align="${socAlign}" style="padding: ${socPadding};">
              <table border="0" cellspacing="0" cellpadding="0" style="margin: 0 auto;">
                <tr>
                  ${socialLinksHtml}
                </tr>
              </table>
            </td>
          </tr>
        `;
        }

        case 'DIVIDER':
          return `
          <tr>
            <td style="padding: ${getPadding(content)};">
              <table border="0" cellspacing="0" cellpadding="0" width="100%">
                <tr>
                  <td style="border-bottom: ${content.height || '1px'} solid ${content.color || '#e5e7eb'}; font-size: 1px; line-height: 1px;">&nbsp;</td>
                </tr>
              </table>
            </td>
          </tr>
        `;

        case 'SPACER':
          return `
          <tr>
            <td height="${parseInt(content.height) || 24}" style="font-size: 1px; line-height: ${parseInt(content.height) || 24}px;">&nbsp;</td>
          </tr>
        `;

        default:
          return '';
      }
    })
    .join('\n');

  return `
<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Email</title>
<style>
  body { margin: 0; padding: 0; background-color: #f4f7f6; font-family: sans-serif; }
  table { border-collapse: collapse; }
</style>
</head>
<body style="margin: 0; padding: 0; background-color: #f4f7f6;">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #f4f7f6; padding: 20px 0;">
    <tr>
      <td align="center">
        <!-- Main Container -->
        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="max-width: 600px; width: 100%; background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
          ${contentHtml}
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
  `.trim();
}

function escapeHtml(unsafe) {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
